import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"max-width":"350px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#747474","margin-left":"15px"} }, "Inregistrare documente", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 3,
  style: {"color":"#747474","margin-left":"15px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "q-pa-md" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "LICENȚA DE UTILIZARE PLATFORMA ODOCS")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, " ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Cod Licență:")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, " ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Denumire: ODOCS - Sistem de management al dezvoltarii aplicatiei Brandteam")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 21022023")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: Unlimited")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231_29")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Denumire: ODOCS - BI")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 13062023")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: Unlimited")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "5915648210220231_1615"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Denumire: ODOCS - Pachet Office")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","font-size":"10pt"} }, "Issue date: 13072023")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-left":"36pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, "Users: 10")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }, " ")
], -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { style: {"margin-top":"0pt","margin-bottom":"0pt","line-height":"115%","widows":"0","orphans":"0","font-size":"10pt"} }
const _hoisted_27 = { class: "absolute-bottom-right q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
      clickable: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToViewWithParamString('Dashboard', 'documente_repartizate')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "primary",
              name: "dashboard"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Dashboard")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_badge, {
                  color: "blue",
                  transparent: "",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfMyDocuments)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_badge, {
                  color: "orange",
                  transparent: "",
                  style: {"position":"relative","margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfPendingToRegister)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_badge, {
                  color: "red",
                  transparent: "",
                  style: {"position":"relative","margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfTask)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_badge, {
                  color: "green",
                  transparent: "",
                  style: {"position":"relative","margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrOfTaskIstoric)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.user.auth_for_proiect=='y')
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 0,
                      color: "cyan",
                      transparent: "",
                      style: {"position":"relative","margin-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrProjectTask)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (['APP_DEV', 'APP_SOPHORE', 'APP_CV', 'APP_URBANESQ', 'APP_MEAT', 'APP_BRANDTEAM', 'APP_HR'].includes(_ctx.APP_NAME))
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 1,
                      color: "purple",
                      transparent: "",
                      style: {"position":"relative","margin-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrAssetEvenimente)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_ripple]
    ]),
    (_ctx.user.is_admin=='y' || _ctx.user.auth_for_search=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 0,
          clickable: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView('Search')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "search"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Cautare document")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_document_portal=='y') && ['APP_DEV', 'APP_CV', 'APP_CJCV', 'APP_HR'].includes(_ctx.APP_NAME))
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 1,
          clickable: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToView('DocumenteCetateni')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "chrome_reader_mode"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Solicitari cetateni")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_input_intrare=='y' || _ctx.user.auth_for_input_exit=='y' || _ctx.user.auth_for_input_intern=='y')
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 0,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Registratura"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_input_intrare=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToView('Intrare')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "input"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Document intrare")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_input_exit=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToView('Iesire')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "output"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Document iesire")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_input_intern=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToView('Intern')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "system_update_alt"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Document intern")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y' || _ctx.user.auth_for_search=='y' || _ctx.user.auth_for_document_nefinalizat=='y' || _ctx.user.auth_for_reportregistryoffice=='y')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Actiuni documente"))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_document_nefinalizat=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToView('DocumentNefinalizat')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "source"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Documente nefinalizate "),
                                  (_ctx.eventSourceNrBadge.nrDocumenteNeFinalizate>0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 0,
                                        color: "orange",
                                        transparent: "",
                                        style: {"position":"relative","top":"-5px","left":"5px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrDocumenteNeFinalizate)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 5,
                        clickable: "",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToView('DeRepartizat')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "device_hub"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Repartizare documente "),
                                  (_ctx.eventSourceNrBadge.nrDocumenteDeRepartizate>0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 0,
                                        color: "red",
                                        transparent: "",
                                        style: {"position":"relative","top":"-5px","left":"5px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrDocumenteDeRepartizate)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 6,
                        clickable: "",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToView('ToateRepartizate')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "layers"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Documente repartizate "),
                                  (_ctx.eventSourceNrBadge.nrAllAllocatedDocs>0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 0,
                                        color: "green",
                                        transparent: "",
                                        style: {"position":"relative","top":"-5px","left":"5px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.abbreviateNumber(_ctx.eventSourceNrBadge.nrAllAllocatedDocs)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_search=='y' || _ctx.user.auth_for_reportregistryoffice=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 7,
                        clickable: "",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToView('Reports')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "bubble_chart"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Rapoarte registratura")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToView('StatusNumere')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "bookmark_border"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Status numere")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_certificaturbanism=='y' || _ctx.user.auth_for_serviciidetransport=='y') && ['APP_DEV', 'APP_HR'].includes(_ctx.APP_NAME))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 1,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Servicii electronice"
              }, {
                default: _withCtx(() => [
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_certificaturbanism=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToView('CertificateUrbanism')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "web_asset"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Certificate urbanism")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_serviciidetransport=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToView('ServiciiDeTransport')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "web_asset"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Autorizatii speciale transport")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_asset=='y') && ['APP_DEV', 'APP_SOPHORE', 'APP_CV', 'APP_URBANESQ', 'APP_MEAT', 'APP_BRANDTEAM', 'APP_HR'].includes(_ctx.APP_NAME))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 2,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Active"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToViewWithParamIsDialogPopup('EditAsset', false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "web_asset"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Activ nou")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToViewWithParamString('Assets', ' ')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "web_asset"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Lista active")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToViewWithParam('AssetsNotificationsList', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "web_asset"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Evenimente")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_financiar=='y') && ['APP_DEV', 'APP_URBANESQ'].includes(_ctx.APP_NAME))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 3,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Financiar"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToView('Facturi')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "receipt_long"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Facturi")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToView('Parteneri')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "handshake"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Parteneri")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goToView('CursValutar')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "currency_exchange"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Curs valutar")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunipersonal=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 4,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Operatiuni personal"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToViewWithParam('PontajPrezenta', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "door_sliding"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaj prezenta")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goToViewWithParam('PontajProiect', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "door_sliding"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaj proiect")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.goToViewWithParam('PontajTask', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "door_sliding"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaj task")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goToViewWithParam('MyTimesRequests', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "date_range"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Concedii")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goToViewWithParam('NomDeplasari', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Deplasari")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goToViewWithParam('NomDeconturi', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Deconturi")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.goToViewWithParam('Referate', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Referat")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.goToViewWithParam('Cereri', 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Cereri de avans")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (['APP_DEV', 'APP_HR', 'APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.goToView('Pontaje')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "door_sliding"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Istoric acces")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.is_admin=='y')
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 5,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Arhiva"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.goToViewWithParam('Arhive', 0)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Arhivare")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_managementdezvoltare=='y' || _ctx.user.auth_for_reportbianalytics=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 6,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Management dezvoltare"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goToViewWithParam('Taskuri', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Taskuri")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.goToView('Proiecte')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Proiecte")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.goToViewWithParam('PontajTask', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaje task")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'bitbucket')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cod sursa")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'jira')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Service desk")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'figma')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Proiectare UI")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'mantis')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Mantis")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'confluence')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Documentatii proiecte")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 5,
                        clickable: "",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'apipostman')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("API management")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 6,
                        clickable: "",
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.goToViewWithParamString('ApiExternIntergation', 'chatgpt')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("AI code assistant")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_reportbianalytics=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 7,
                        clickable: "",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.goToView('BIAnalytics')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("BI analytics")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 8,
                        clickable: "",
                        onClick: _ctx.openLink
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Office")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 9,
                        clickable: "",
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.goToView('Documentator')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Documentare cod")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniconducere=='y' || _ctx.user.auth_for_restrictionsholiday=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 7,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Operatiuni conducere"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniconducere=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.goToViewWithParam('AdminPrezenta', 0)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Monitorizare Concedii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniconducere=='y' || _ctx.user.auth_for_restrictionsholiday=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.goToViewWithParam('RestrictiiConcediu', 0)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Restrictionari concediu")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunihr=='y' || _ctx.user.auth_for_angajari=='y' || _ctx.user.auth_for_medicinamuncii=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 8,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "HR"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.goToViewWithParam('PontajPrezenta', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "door_sliding"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaj prezenta")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.goToViewWithParam('PontajProiect', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "door_sliding"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Pontaj proiect")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_monitoringholiday=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.goToViewWithParam('AdminPrezenta', 1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Monitorizare Concedii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goToViewWithParam('MyTimesRequests', (_ctx.user.is_admin=='y' || _ctx.user.auth_for_timerequesthr=='y') ? 1 : 0)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "date_range"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Concedii")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_restrictionsholiday=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.goToViewWithParam('RestrictiiConcediu', 1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Restrictionari concediu")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_rightdaysholiday=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.goToView('DrepturiCO')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Drepturi CO")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_officialdaysoff=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.goToView('NomZiLibereOficial')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "date_range"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Administrare zile libere")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.goToViewWithParam('NomDeplasari', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Deplasari")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.goToViewWithParam('NomDeconturi', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Deconturi")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.goToViewWithParam('Referate', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Referat")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.goToViewWithParam('Cereri', 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "description"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Cereri de avans")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.goToViewWithParam('Arhive', 1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Arhive")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.goToView('ReportsHR')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "date_range"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Rapoarte")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_ripple]
                  ]),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_medicinamuncii=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 5,
                        clickable: "",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.goToView('MedicinaMuncii')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Medicina muncii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y') && ['APP_DEV', 'APP_HR', 'APP_MAGIC'].includes(_ctx.APP_NAME))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 9,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Operatiuni Acces"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.goToView('Monitorizare')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "door_sliding"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(['APP_MAGIC'].includes(_ctx.APP_NAME) ? 'Condica' : 'Monitorizare'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniacces=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.goToView('AlocariEntitatiAcces')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "assignment_ind"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Alocari acces")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' ))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 10,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Organizatie"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.goToView('HRMSPositions')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "toc"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Posturi")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.goToView('HRMSPositions')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "manage_accounts"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Angajari")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' )
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.goToView('HRMSPersonal')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "contacts"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Gestiune Personal")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.goToView('HRMSOrganigrama')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "corporate_fare"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Organigrama")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.goToView('HRMSPerformancePeople')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "moving"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Evaluare performante")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunievenimente=='y' || _ctx.user.auth_for_operatiuniclienti=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 11,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Roluri"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiuniclienti=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.goToView('Clienti')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "contacts"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Clienti")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_operatiunievenimente=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.goToView('Evenimente')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "event"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Evenimente")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.goToView('CampaniiEmail')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "campaign"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Campanii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.is_admin=='y' || _ctx.user.auth_for_posturi == 'y')
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 12,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Nomenclatoare"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.goToView('NomCateg')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "insert_drive_file"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Categorii documente")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.goToView('NomTipDoc')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Tipuri documente")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.goToView('NomRegistre')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "chrome_reader_mode"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Registre")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' && ['APP_DEV', 'APP_SOPHORE', 'APP_CV', 'APP_URBANESQ', 'APP_MEAT', 'APP_HR'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.goToView('NomCategActive')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "insert_drive_file"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Categorii active")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' && ['APP_DEV', 'APP_SOPHORE', 'APP_CV', 'APP_URBANESQ', 'APP_MEAT', 'APP_HR'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.goToView('NomTipActive')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Tipuri active")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 5,
                        clickable: "",
                        onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.goToView('NomJobs')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Functii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 6,
                        clickable: "",
                        onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.goToView('NomEntitateAcces')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: ['APP_MAGIC'].includes(_ctx.APP_NAME) ? 'class' : 'description'
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Entitati acces")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 7,
                        clickable: "",
                        onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.goToView('Adrese')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Adrese")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 8,
                        clickable: "",
                        onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.goToView('NomJudet')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "map"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Judete")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 9,
                        clickable: "",
                        onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.goToView('NomLocalitate')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "map"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Localitati")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y') && ['APP_DEV', 'APP_URBANESQ'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 10,
                        clickable: "",
                        onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.goToView('NomUnitatiMasura')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "straighten"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("UM")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' || _ctx.user.auth_for_posturi == 'y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 11,
                        clickable: "",
                        onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.goToView('Posturi')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Posturi")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_locatiiarhiva=='y'))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 13,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Locatii arhiva"
              }, {
                default: _withCtx(() => [
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_locatiiarhiva=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.goToView('NomCladiriArhiva')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cladiri")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_locatiiarhiva=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.goToView('NomCamereArhiva')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Camere")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_locatiiarhiva=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.goToView('NomDulapuriArhiva')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Dulapuri")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_locatiiarhiva=='y'))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.goToView('NomRafturiArhiva')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "description"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Rafturi")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.is_admin=='y')
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 14,
                "switch-toggle-side": "",
                "expand-separator": "",
                label: "Administrare"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.is_admin=='y' && ['APP_DEV', 'APP_MEAT', 'APP_MULTICOMPANY'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        clickable: "",
                        onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.goToView('NomCompanies')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "business"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Companii")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 1,
                        clickable: "",
                        onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.goToView('NomUsers')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "people"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Utilizatori")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 2,
                        clickable: "",
                        onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.goToView('NomFlux')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "account_tree"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Fluxuri")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 3,
                        clickable: "",
                        onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.goToView('NomOrgUnit')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "assignment_ind"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Org Unit")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y' && ['APP_DEV', 'APP_URBANESQ'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 4,
                        clickable: "",
                        onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.goToView('SetariCompanie')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "room_preferences"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Setări companie")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 5,
                        clickable: "",
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.goToView('ParamsTypeFiles')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "attach_file"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Parametri atasamente")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.user.is_admin=='y')
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 6,
                        clickable: "",
                        onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.goToView('LogAdmin')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "android"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Log")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (['APP_MAGIC'].includes(_ctx.APP_NAME))
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: 7,
                        clickable: "",
                        onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.aboutPopupOpen = true))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                color: "primary",
                                name: "info"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Info")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.aboutPopupOpen,
      "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.aboutPopupOpen) = $event)),
      persistent: "",
      "transition-show": "slide-down",
      "transition-hide": "slide-up"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"90vw","min-height":"30vw","max-height":"30vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, "Versiune platforma Odocs: V" + _toDisplayString(_ctx.APP_INFORMATION.version), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createVNode(_component_q_btn, {
                      label: "Inchide",
                      dense: "",
                      flat: "",
                      icon: "close",
                      size: "sm",
                      color: "primary"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}